import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';
import { AxiosResponse } from 'axios';
import { PreavisInterventionDTO } from '@/models/PreavisIntervention/PreavisInterventionDTO';
import { CreatePreavisInterventionDTO } from '@/models/PreavisIntervention/CreatePreavisInterventionDTO';
import { UpdatePreavisInterventionDTO } from '@/models/PreavisIntervention/UpdatePreavisInterventionDTO';
import { UpdateActivationPreavisInterventionDTO } from '@/models/PreavisIntervention/UpdateActivationPreavisInterventionDTO';

class PreavisInterventionService {
    public getPreavisInterventions(
        siteIds?: number | number[],
        equipementIds?: number | number[],
        sort?: string
    ): Promise<AxiosResponse<PreavisInterventionDTO[]>> {
        const params: any = {};
        if (typeof siteIds !== 'undefined') params.siteIds = siteIds;
        if (typeof equipementIds !== 'undefined') params.equipementIds = equipementIds;
        if (sort) params.sort = sort;

        return http.get<PreavisInterventionDTO[]>(Routes.PreavisInterventionRoutes.GetPreavisInterventions(), {
            params: Object.keys(params).length ? params : undefined,
        });
    }

    public createPreavisIntervention(
        dto: CreatePreavisInterventionDTO
    ): Promise<AxiosResponse<PreavisInterventionDTO>> {
        return http.post<PreavisInterventionDTO>(Routes.PreavisInterventionRoutes.CreatePreavisIntervention(), dto);
    }

    public deletePreavisIntervention(preavisId: number): Promise<AxiosResponse<void>> {
        return http.delete(Routes.PreavisInterventionRoutes.DeletePreavisIntervention(preavisId));
    }

    public updatePreavisIntervention(
        preavisId: number,
        dto: UpdatePreavisInterventionDTO
    ): Promise<AxiosResponse<PreavisInterventionDTO>> {
        return http.put<PreavisInterventionDTO>(
            Routes.PreavisInterventionRoutes.UpdatePreavisIntervention(preavisId),
            dto
        );
    }

    public updateActivationPreavisIntervention(
        preavisId: number,
        dto: UpdateActivationPreavisInterventionDTO
    ): Promise<AxiosResponse<PreavisInterventionDTO>> {
        return http.put<PreavisInterventionDTO>(
            Routes.PreavisInterventionRoutes.UpdateActivationPreavisIntervention(preavisId),
            dto
        );
    }
}

export default new PreavisInterventionService();
